
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_45687","data-name":"Group 45687"}},[_c('rect',{attrs:{"id":"Rectangle_15343","data-name":"Rectangle 15343","width":"30","height":"30","fill":"none"}}),_c('path',{attrs:{"id":"Path_32794","data-name":"Path 32794","d":"M23.942 19.735a.749.749 0 00-.162-.244L20.6 16.31a.75.75 0 10-1.061 1.06l1.9 1.9H8.56l1.9-1.9a.75.75 0 00-1.06-1.06l-3.18 3.181a.753.753 0 000 1.061l3.18 3.182a.75.75 0 001.061-1.061l-1.9-1.9h12.878l-1.9 1.9a.75.75 0 001.061 1.061l3.182-3.182a.753.753 0 00.162-.817"}}),_c('path',{attrs:{"id":"Path_32795","data-name":"Path 32795","d":"M6.058 10.265a.749.749 0 00.162.244l3.18 3.182a.75.75 0 001.061-1.06l-1.9-1.9H21.44l-1.9 1.9a.75.75 0 101.061 1.06l3.182-3.182a.753.753 0 000-1.061L20.6 6.266a.75.75 0 10-1.061 1.061l1.9 1.9H8.561l1.9-1.9A.75.75 0 009.4 6.266L6.22 9.448a.753.753 0 00-.162.817"}})])])
          )
        }
      }
    